import { PrivacyRequestsItem } from '@/services/privacyRequestTracker';
import { ColumnDef } from '@tanstack/react-table';
import HelpPopoverHover from '@/components/HelpPopoverHover';
import { TOUR_STEP_IDS } from '@/lib/tour-constants';

import { Timestamp as FirebaseTimestamp }  from 'firebase/firestore';


import React from 'react';
import { Edit, Eye, Trash } from 'lucide-react';
import { Button } from '@/components/ui/button';

import {
  AlertDialog,
  AlertDialogTrigger,
  AlertDialogContent,
  AlertDialogHeader,
  AlertDialogTitle,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogCancel,
  AlertDialogAction,
} from "@/components/ui/alert-dialog";

interface PrivacyRequestActionsProps {
  onEdit?: (row: PrivacyRequestsItem) => void;
  onView?: (row: PrivacyRequestsItem) => void;
  onDelete?: (row: PrivacyRequestsItem) => void;
  helpData: any;
}

/*
name
email
phone
status
actions
 */

export const getPrivacyRequestColumns = (onActions: PrivacyRequestActionsProps): ColumnDef<PrivacyRequestsItem, any>[] => [
  {
    header: () => (
      <span className="bg-transparent px-2 py-1 rounded font-semibold text-center w-full block">
        <HelpPopoverHover config={onActions.helpData?.['table.header.id']}>ID</HelpPopoverHover>
      </span>
    ),
    accessorKey: 'friendly_id',
    cell: ({ getValue }) => {
      const id = getValue();
      // console.log('asd', id)
      return <span className="font-medium text-center w-full block">PRT-{id}</span>
    }
  },
  {
    accessorKey: 'metadata.created_at',
    header: () => (
      <span className="bg-transparent px-2 py-1 rounded font-semibold text-center w-full block">
        <HelpPopoverHover config={onActions.helpData?.['table.header.requestedDate']}>Date</HelpPopoverHover>
      </span>
    ),
    cell: ({ getValue }) => {
      const stamp = getValue();

      if (stamp) {
        return <span className="font-medium text-center w-full block">{stamp.toLocaleDateString()}</span>
      }

      return <span className="font-medium text-center w-full block">Unknown</span>
    }
  },
  {
    header: () => (
      <span className="bg-transparent px-2 py-1 rounded font-semibold text-center w-full block">
        <HelpPopoverHover config={onActions.helpData?.['table.header.name']}>Name</HelpPopoverHover>
      </span>
    ),
    accessorKey: 'name',
    cell: ({getValue}) => <span className="font-medium text-center w-full block">{getValue()}</span>,
  },
  {
    header: () => (
      <span className="bg-transparent px-2 py-1 rounded font-semibold text-center w-full block">
        <HelpPopoverHover config={onActions.helpData?.['table.header.email']}>Email</HelpPopoverHover>
      </span>
    ),
    accessorKey: 'email',
    cell: ({getValue}) => <span className="font-medium text-center w-full block">{getValue()}</span>,
  },
  {
    header: () => (
      <span className="bg-transparent px-2 py-1 rounded font-semibold text-center w-full block">
        <HelpPopoverHover config={onActions.helpData?.['table.header.phone']}>Phone</HelpPopoverHover>
      </span>
    ),
    accessorKey: 'phone',
    cell: ({getValue}) => <span className="font-medium text-center w-full block">{getValue()}</span>,
  },
  {
    header: () => (
      <span className="bg-transparent px-2 py-1 rounded font-semibold text-center w-full block">
        <HelpPopoverHover config={onActions.helpData?.['table.header.status']}>Status</HelpPopoverHover>
      </span>
    ),
    accessorKey: 'status',
    cell: ({getValue}) => <span className="font-medium text-center w-full block">{getValue()}</span>,
  },
  {
    header: () => (
      <span className="bg-transparent px-2 py-1 rounded font-semibold text-center w-full block">
        <HelpPopoverHover config={onActions.helpData?.['table.header.actions']}>Actions</HelpPopoverHover>
      </span>
    ),
    id: 'actions',
    cell: ({ row }) => (
      <div id={TOUR_STEP_IDS.PRIVACY_REQUESTS_ACTION_BUTTONS} className="flex gap-1 justify-center">
        <Button variant="ghost" size="icon" onClick={() => onActions.onView?.(row.original)}>
          <Eye className="h-4 w-4" />
        </Button>
        <AlertDialog>
          <AlertDialogTrigger asChild>
            <Button variant="ghost" size="icon">
              <Trash className="h-4 w-4" />
            </Button>
          </AlertDialogTrigger>

          <AlertDialogContent className="bg-secondary">
            <AlertDialogHeader>
              <AlertDialogTitle>Delete this request?</AlertDialogTitle>
              <AlertDialogDescription>
                This will delete this request
              </AlertDialogDescription>
            </AlertDialogHeader>

            <AlertDialogFooter>
              <AlertDialogCancel>Cancel</AlertDialogCancel>
              <AlertDialogAction asChild>
                <Button
                  variant="destructive"
                  onClick={async () => {
                    try {
                      onActions.onDelete?.(row.original);
                    } catch (err) {
                      console.error("[deletePrivacyRequestItem]", err);
                    }
                  }}
                >
                  Confirm Delete
                </Button>
              </AlertDialogAction>
            </AlertDialogFooter>
          </AlertDialogContent>
        </AlertDialog>
      </div>
    ),
  }
];
